/**
 * NotificationsModalWrapper
 *
 * Renders the global `<NotificationsModal />` whenever the
 * `NotificationsModalContext` says it should be open. Mirrors the
 * existing `AuthModalWrapper` / `UsernameModalWrapper` pattern in
 * `App.tsx` so that any descendant of `NotificationsModalProvider` can
 * call `useNotificationsModal().open()` without owning modal state.
 *
 * Mounted once near the app shell (alongside the auth/username wrappers
 * in `App.tsx`). Keeping the modal instance up here means the AppBar
 * bell, the realtime in-app toast click handler, and the
 * `/notifications` deep-link route all hit the same modal instance.
 */

import React from "react";
import NotificationsModal from "components/Notifications/NotificationsModal";
import { useNotificationsModal } from "context/NotificationsModalContext";

const NotificationsModalWrapper: React.FC = () => {
  const { isOpen, close } = useNotificationsModal();

  if (!isOpen) {
    return null;
  }

  return (
    <NotificationsModal
      onClose={close}
      onNotificationsRead={() => {}}
    />
  );
};

export default NotificationsModalWrapper;
